import { jsPDF } from 'jspdf';
import { drawModernInvoiceTemplate } from './invoiceTemplate';

export async function buildFacturePdfDoc(facture) {
  const doc = new jsPDF({ compress: true, putOnlyUsedFonts: true });
  await drawModernInvoiceTemplate(doc, facture);
  return doc;
}

export async function openFacturePdfInNewTab(facture) {
  const doc = await buildFacturePdfDoc(facture);
  const blob = doc.output('blob');
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
}

export async function downloadFacturePdf(facture) {
  const doc = await buildFacturePdfDoc(facture);
  const numero = facture.numero || facture.numero_facture;
  const nomFichier = numero
    ? `Facture-Officielle-${numero}.pdf`
    : `Brouillon-facture-${facture.id}.pdf`;
  doc.save(nomFichier);
}

